(function () {
  // Cache of the last-rendered recommendation HTML, keyed by the sorted
  // list of product ids currently in the cart. As long as the cart hasn't
  // actually changed, opening/closing the drawer re-uses this instantly
  // instead of re-fetching from the recommendations section endpoint.
  var cache = { key: null, html: null };

  function computeCacheKey(cartProductIds) {
    return cartProductIds.slice().sort(function (a, b) { return a - b; }).join(',');
  }

  function getRoot() {
    return document.getElementById('cart-recommendations');
  }

  function getTrack() {
    return document.getElementById('cart-recommendations-track');
  }

  function applyHtml(html) {
    var root = getRoot();
    var track = getTrack();
    if (!root || !track) return;

    // The /recommendations/products?section_id=... endpoint's exact
    // wrapping (raw section content vs. wrapped in a
    // #shopify-section-cart-recommendations div, the way ?section_id=
    // fetches elsewhere in this theme are) isn't something that can be
    // confirmed without hitting the live endpoint, so this unwraps
    // defensively rather than assuming either shape.
    var content = html || '';
    var wrapperMatch = content.match(/<div[^>]*id=["']shopify-section-cart-recommendations["'][^>]*>([\s\S]*)<\/div>\s*$/);
    if (wrapperMatch) {
      content = wrapperMatch[1];
    }

    track.innerHTML = content;

    if (track.querySelector('.CartRecommendations__Card')) {
      root.style.display = '';
    } else {
      root.style.display = 'none';
    }
  }

  function getCartProductIdsFromDom() {
    // The drawer already server-renders each line item with
    // data-product-id (see snippets/cart-items.liquid) — reading it here
    // is synchronous and free, versus a round-trip to /cart.js just to
    // learn the same thing a moment after the page already told us.
    var wrappers = document.querySelectorAll('#sidebar-cart .CartItemWrapper[data-product-id]');
    var ids = [];
    wrappers.forEach(function (el) {
      var id = parseInt(el.getAttribute('data-product-id'), 10);
      if (id) ids.push(id);
    });
    return ids; // Order matches display order — newest item first (see cart-items.liquid's display_items reverse for the drawer).
  }

  function fetchRecommendationsForProductIds(cartProductIds) {
    if (!cartProductIds.length) {
      applyHtml('');
      return Promise.resolve();
    }

    var baseProductId = cartProductIds[0]; // Newest item is first in drawer order.
    var cacheKey = computeCacheKey(cartProductIds);

    if (cache.key === cacheKey && cache.html !== null) {
      applyHtml(cache.html);
      return Promise.resolve();
    }

    var url = '/recommendations/products?section_id=cart-recommendations&product_id=' +
      baseProductId + '&limit=8&intent=related';

    return fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        cache.key = cacheKey;
        cache.html = html;
        applyHtml(html);
      })
      .catch(function (err) {
        console.error('[Cart recommendations] Failed to load:', err);
        var root = getRoot();
        if (root) root.style.display = 'none';
      });
  }

  function fetchRecommendations() {
    var root = getRoot();
    if (!root) return; // Drawer not open / cart empty / snippet not rendered — nothing to do.

    var domProductIds = getCartProductIdsFromDom();

    if (domProductIds.length) {
      fetchRecommendationsForProductIds(domProductIds);
      return;
    }

    // Fallback for the rare case this runs before the drawer's item
    // markup exists yet (e.g. very first call before any AJAX render has
    // happened) — reads the cart directly instead.
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (!cart.items.length) {
          applyHtml('');
          return;
        }
        var cartProductIds = cart.items.map(function (item) { return item.product_id; }).reverse();
        return fetchRecommendationsForProductIds(cartProductIds);
      })
      .catch(function (err) {
        console.error('[Cart recommendations] Failed to load:', err);
        var root2 = getRoot();
        if (root2) root2.style.display = 'none';
      });
  }

  function scrollByCards(direction) {
    var track = getTrack();
    if (!track) return;
    var card = track.querySelector('.CartRecommendations__Card');
    var cardWidth = card ? card.getBoundingClientRect().width + 12 : 150; // + gap
    track.scrollBy({ left: direction * cardWidth * 2, behavior: 'smooth' });
  }

  // Event delegation on document so this keeps working even after the
  // drawer's inner HTML (including these nodes) gets swapped out by
  // Cart.prototype._replaceContent.
  document.addEventListener('click', function (e) {
    var addButton = e.target.closest && e.target.closest('.CartRecommendations__Add');
    if (addButton) {
      var variantId = addButton.getAttribute('data-variant-id');
      if (!variantId) return;

      addButton.disabled = true;
      addButton.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          // dispatch on document.documentElement, not document — see
          // assets/theme.js, CartSection._attachListeners:
          // `this.documentDelegate = new domDelegate.Delegate(document.documentElement)`
          // then `this.documentDelegate.on('cart:refresh', this._rerenderCart...)`.
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          fetchRecommendations();
        })
        .catch(function () {
          addButton.disabled = false;
          addButton.textContent = 'Add';
        });
      return;
    }

    var prevButton = e.target.closest && e.target.closest('#cart-recommendations-prev');
    if (prevButton) {
      scrollByCards(-1);
      return;
    }

    var nextButton = e.target.closest && e.target.closest('#cart-recommendations-next');
    if (nextButton) {
      scrollByCards(1);
    }
  });

  // The theme dispatches these on essentially every cart mutation (add to
  // cart, quantity change, line removal, and the drawer's own Add button
  // above). Re-fetch every time so the carousel reflects the current
  // cart, and reappears after the drawer markup gets AJAX-refreshed.
  document.addEventListener('cart:refresh', fetchRecommendations);
  document.addEventListener('product:added', fetchRecommendations);

  // 'cart:content-updated' fires from theme.js's CartSection._replaceContent
  // itself — the one choke point every cart re-render passes through
  // (quantity +/-, remove item, note changes), including paths that don't
  // fire 'cart:refresh' or 'product:added' at all.
  document.addEventListener('cart:content-updated', fetchRecommendations);

  // Also cover plain drawer opens (e.g. clicking the cart icon with no
  // cart mutation involved) in case the markup was refreshed while the
  // drawer was closed.
  document.addEventListener('click', function (e) {
    var opener = e.target.closest && e.target.closest('[data-action="open-drawer"][data-drawer-id="sidebar-cart"]');
    if (opener) {
      fetchRecommendations();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fetchRecommendations);
  } else {
    fetchRecommendations();
  }
})();